import { Component } from '@angular/core';
import {LugaresService} from "../services/lugares.service";
import { ActivatedRoute } from '@angular/router';
// Sweet Alert
import swal from 'sweetalert2';

// RXJS
import {Observable} from 'rxjs';
import 'rxjs/Rx';
import {FormControl} from '@angular/forms';

// Http :
import {Http} from "@angular/http";

@Component({
	selector: 'app-crear',
	templateUrl: './crear.component.html',
	styleUrls: ['./crear.component.css']
})

export class CrearComponent {
	// Definiciones
	titularAlerta:string='';

	lugar:any = {};
	firebaseResponse:boolean=false;
	flagSuccess:boolean=false;
	mostrarSuccessAction:boolean=false;

	//resultado accion guardar
	saveAction:any=false;
	//
	id:any=null;

	// buscador
	results$: Observable<any>;
	public searchField: FormControl;

	// Tests
	showListSearch:any=false;
	flagResultados:boolean=true;


	// CONSTRUCTOR
	// , private alertService: SweetAlertService
	constructor(private lugaresService: LugaresService, private route: ActivatedRoute, private http: Http) {     

		//lugaresService.guardarLugar
		this.id=this.route.snapshot.params['id'];

		console.log(this.id);
		this.titularAlerta='Ingresando campos';

		// Record que ya existe 
		if(this.id!='new'){
			//suscribir a un objeto					
			this.lugaresService.getLugar(this.id).
				valueChanges().subscribe((lugar)=>{ //.
					this.lugar=lugar;
				})					
			// nuevo mecanismo:
			/*
			this.lugaresService.getLugar(this.id).
			valueChanges().subscribe((lugar)=>{
				this.lugar=lugar;
				var me=this;
				this.lugar = Object.keys(me.lugar).map((key)=>me.lugar[key]);        
			})
			*/			
			// debugger;			
		}

		// buscador 
		const URL = 'https://maps.google.com/maps/api/geocode/json';
		this.searchField = new FormControl();

		try{

			if (true){ //this.flagResultados
				this.results$ = this.searchField.valueChanges
				.debounceTime(500)
				.switchMap(query =>
					this.http.get(`${URL}?address=${query}`)
				)
				.map(response => response.json())
				.map(response =>response.results)

				console.log("resultados ::: ::: ::: " ,this.results$)
			}			
		}
		catch(ex){
			console.log("Hubo una excepcion")
		}


		//this.searchField.add
	}
	
	valueChange(event){
		console.log(event)
	}
	// Metodo especifico para la Busqueda
	
	seleccionarDireccion(direccion){
		console.log(direccion);
		
		/*
        this.lugar.calle = direccion.address_components[1].long_name+' '+direccion.address_components[0].long_name;
        this.lugar.ciudad = direccion.address_components[4].long_name;
		this.lugar.pais = direccion.address_components[6].long_name;
		this.showListSearch=false;
		console.log("click y esconder los <li></li>")
		this.results$=null;
		*/


		const addressComponents = direccion.address_components
		const adrressParams: any = {}
		for (let i = 0, len = addressComponents.length; i < len; i++) {
		  const type = addressComponents[i].types[0].toString()
		  console.log(" type ::: "+ type)
		  switch (type) {
			case'street_number':
			  adrressParams.street_number = addressComponents[i].long_name
			  break
			case'route':
			  adrressParams.route = addressComponents[i].long_name
			  break
			case'locality':
			  adrressParams.locality = addressComponents[i].long_name
			  break
			case'country':
			  adrressParams.country = addressComponents[i].long_name
			  break
		  }
		}
		this.lugar.calle = `${adrressParams.route}${adrressParams.street_number}`
		this.lugar.ciudad = adrressParams.locality
		this.lugar.pais = adrressParams.country		
	}
	

	/*
	seleccionarDireccion(result) {
		const addressComponents = result.address_components
		const adrressParams: any = {}
		for (let i = 0, len = addressComponents.length; i < len; i++) {
		  consttype = addressComponents[i].types[0].toString()
		  switch (type) {
			case'street_number':
			  adrressParams.street_number = addressComponents[i].long_name
			  break
			case'route':
			  adrressParams.route = addressComponents[i].long_name
			  break
			case'locality':
			  adrressParams.locality = addressComponents[i].long_name
			  break
			case'country':
			  adrressParams.country = addressComponents[i].long_name
			  break
		  }
		}
		this.lugar.calle = `${adrressParams.route}${adrressParams.street_number}`
		this.lugar.ciudad = adrressParams.locality
		this.lugar.pais = adrressParams.country
	}
	*/

	// accion, controlador de vista
	guardarLugar(){
		var direccion=this.lugar.calle+','+this.lugar.ciudad+','+this.lugar.pais;
		// Obtener primero la GEODATA
		// valueChanges()
		this.lugaresService.obtenerGeodata(direccion).subscribe((result)=>{
			//debugger;
			this.lugar.lat=result.json().results[0].geometry.location.lat;
			this.lugar.lng=result.json().results[0].geometry.location.lng;


			if(this.id!='new'){
				//   E D I T A R 
				this.titularAlerta='Registro Editado en Firebase'
				this.firebaseResponse=true;
				this.lugaresService.editarLugar(this.lugar);
				swal('Edición de registros', this.titularAlerta, 'success')        
			}else{
				//  G U A R D A R 
				// Bug
				this.lugar.id = Date.now();
				this.titularAlerta='Registro Creado en Firebase';
				this.firebaseResponse=true;
				this.lugaresService.guardarLugar(this.lugar)
					//.subscribe((response)=>console.log(response), (e)=>console.log(e));
				console.log("Intentando guardar Lugar", this.lugar);
				swal('Nuevo Registro', this.titularAlerta, 'success');
			}      
			this.lugar={};
		});
	}

	cerrarAlert(accion:number){
		if(accion==8){
			//cerrar
			this.flagSuccess=true;
			console.log(this.flagSuccess);
		}
	}

	ingresoTexto(event){
		console.log("LOL",event.target.value)
		if (event.target.value == null || event.target.value == '' || event.target.value == 0){
			console.log("Vacío")
			this.flagResultados=false;
		}else{
			console.log("Si hay datos!")
			this.flagResultados=true;
		}
	}
}


// WEBPACK FOOTER //
// C:/Users/USUARIO/Documents/Platzi/cursos__2017/Angular_4_PROFESIONAL/proyectos/platzisquare2/src/app/crear/crear.component.ts